export enum EidType {
  SE = 'eid:bankid',
  NO = 'eid:bankid-no',
  MitID = 'eid:mitid',
  BankIDFI = 'eid:bankid-fi',
}
